import { constants, typographyStyles } from "@newsela/angelou";

const { heading5Obj, textMObj: text2Obj } = typographyStyles;
const { ui } = constants.colors;
const neutral400 = ui.neutral[400];
const neutral500 = ui.neutral[500];
const greyDark = ui.neutral[600];

export const headingCss = {
  ...heading5Obj,
  display: "block",
  color: greyDark,
  fontWeight: "bold",
  margin: "0 0 16px 0",
};

export const questionTextCss = {
  marginBottom: "24px",
  p: {
    ...text2Obj,
    color: greyDark,
    margin: "0",
  },
};

export const editingAreaCss = {
  ...text2Obj,
  color: greyDark,
  width: "100%",
  maxWidth: "100%",
  margin: "8px 0 0",
  padding: "12px 12px 12px 16px",
  border: `1px solid ${neutral400}`,
  borderRadius: "4px",

  "&::placeholder": {
    color: neutral400,
  },
};

export const fieldsetCss = {
  border: 0,
  margin: "0 0 16px 0",
  padding: 0,
};

export const autosaveMessageCss = {
  ...text2Obj,
  color: neutral500,
};
